<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="error-wrap">
    <div class="error-response">
      <div class="icon-wrapper">
        <div class="icon-light" />
      </div>
      <h4>{{ $t('page_429') }}</h4>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageNotFound',
  props: {},
}
</script>

<style lang="stylus" scoped>
.error-wrap
  min-height: "calc(100vh - %s - %s - %s)" % ($header-height $subheader-height $footer-height)
  .error-response
    position: absolute
    top: 50%
    left: 50%
    display: flex
    flex-direction: column
    align-items: center
    transform: translate(-50%, -50%)

    h4
      m-font-size(20, 24)

    .icon-wrapper
      display: flex
      justify-content: center
      align-items: center
      margin-bottom: vw(20px)
      width: vw(78px)
      height: vw(78px)
      border-radius: 50%
      background-color: $bcn-grey

      .icon-light
        m-icon("light", 42)
</style>